<ng-container *ngIf="dataFetched">
  <div
    [attr.class]="'widget-filter ' + (classList | addClassList: { mainClass: 'widget-filter--' })"
    [ngClass]="{ 'widget-filter--checkout': widgetSpecifiedType !== widgetType.pdp }"
  >
    <div
      [attr.class]="
        'widget-params ' +
        (widgetSpecifiedType === widgetType.pdp && '!m-0 !w-full') +
        (classList | addClassList: { mainClass: 'widget-params--' })
      "
    >
      <app-date-picker
        [showCalendar]="isCalendarVisible"
        [calendar]="calendar"
        [isFetching]="isFetching"
        [selectedDatesLabel]="selectedDatesLabel"
        [selectedDates]="selectedDates"
        [currentLang]="currentLang"
        [classList]="classList"
        [attr.class]="
          'widget-params__date-picker ' + (classList | addClassList: { mainClass: 'widget-params__date-picker--' })
        "
        [horizontalLayout]="false"
        [readOnly]="readOnly"
        (shouldShowCalendar)="showHideCalendar($event)"
      />
      <app-calendar
        #calendar
        [cityId]="cityId"
        [propertyId]="propertyId"
        [unitGroupId]="unitGroupId"
        [hidden]="!isCalendarVisible"
        [isHidden]="!isCalendarVisible"
        [dateRange]="checkin ? [checkin, checkout] : null"
        [isEmptyDates]="isEmptyDates"
        [calendarType]="calendarType"
        [attr.class]="'widget-params__calendar ' + (classList ? 'widget-params__calendar--' + classList : '')"
        (hideCalendar)="showHideCalendar($event)"
        (bookedDates)="updateBookedDates($event)"
      />
    </div>
    <div
      *ngIf="widgetSpecifiedType !== widgetType.pdp"
      [attr.class]="'widget-guests ' + (classList | addClassList: { mainClass: 'widget-guests--' })"
    >
      <app-guest-picker
        [openModalOnMobile]="openGuestPickerModalOnMobile"
        [adultsNum]="adults"
        [roomsNum]="rooms"
        [childrenAges]="childrenAges"
        [isFetching]="isFetching"
        [ctaText]="guestCtaText"
        [shouldUpdateGuest]="isFetching || readOnly"
        [updateGuestWithoutRequest]="updateGuestWithoutRequest"
        [attr.class]="
          'widget-params__guest-picker ' + (classList | addClassList: { mainClass: 'widget-params__guest-picker--' })
        "
        [classList]="classList"
        [isExtension]="isExtension"
        (guestsData)="updateGuestsData($event)"
        (dropdownStatus)="onGuestDropdownStatus($event)"
      />
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!dataFetched">
  <div
    [attr.class]="
      widgetSpecifiedType === widgetType.pdp
        ? 'placeholders--pdp ' + (classList | addClassList: { mainClass: 'placeholders--pdp-' })
        : ''
    "
  >
    <div
      class="placeholder-text placeholder-text--datepicker booking-widget__form-date-picker"
      [ngClass]="{ 'placeholder-text--pdp': widgetSpecifiedType === widgetType.pdp }"
    ></div>
    <div
      class="placeholder-text placeholder-text--datepicker booking-widget__form-date-picker"
      [ngClass]="{ 'placeholder-text--pdp': widgetSpecifiedType === widgetType.pdp }"
    ></div>
  </div>
</ng-container>
